var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPipeline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H9V3H1.5L1.5 1.5ZM0 1.5C0 0.671573 0.671573 0 1.5 0H9C9.82843 0 10.5 0.671573 10.5 1.5V3C10.5 3.82843 9.82843 4.5 9 4.5H4.5V9.75C4.5 10.1642 4.83579 10.5 5.25 10.5H6C6 9.67157 6.67157 9 7.5 9H15C15.8284 9 16.5 9.67157 16.5 10.5V12C16.5 12.8284 15.8284 13.5 15 13.5H10.5V18.75C10.5 19.1642 10.8358 19.5 11.25 19.5H12C12 18.6716 12.6716 18 13.5 18H21C21.8284 18 22.5 18.6716 22.5 19.5V21C22.5 21.8284 21.8284 22.5 21 22.5H13.5C12.6716 22.5 12 21.8284 12 21H11.25C10.0074 21 9 19.9926 9 18.75V13.5H7.5C6.67157 13.5 6 12.8284 6 12H5.25C4.00736 12 3 10.9926 3 9.75V4.5H1.5C0.671573 4.5 0 3.82843 0 3V1.5ZM7.5 10.5H15V12H7.5V10.5ZM21 19.5H13.5V21H21V19.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPipeline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pipeline.7992525ac18a4a599368033688498ef5.svg";